import { ROUTE_PAYMENT_VERIFY_PAYMENT } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import VerifyPaymentPageV2 from './payment-verify-v2.page';

export const routePaymentVerifyPayment: RouteObject = {
  path: ROUTE_PAYMENT_VERIFY_PAYMENT,
  Component: VerifyPaymentPageV2,
  loader: setTitleFromLoader('Loading'),
};
